export default "public/069_position_31.svg";